import { createVanIconComponent } from "./van"

const Play = createVanIconComponent("play")
export default Play
